import { render, staticRenderFns } from "./BRyOk.vue?vue&type=template&id=eddc2be8&scoped=true&"
import script from "./BRyOk.vue?vue&type=script&lang=js&"
export * from "./BRyOk.vue?vue&type=script&lang=js&"
import style0 from "./BRyOk.vue?vue&type=style&index=0&id=eddc2be8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eddc2be8",
  null
  
)

export default component.exports